import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ActivityTypeManager } from "../managers/activity-type.manager";
import { ActivityTypeResponseDto } from "../../common/dtos/activity-type/activity-type.response";

@Injectable({
  providedIn: "root"
})
export class ActivityTypeService {

  constructor(
        private activityTypeManager: ActivityTypeManager
  ) {}

  public getActivities(lang: string): Observable<ActivityTypeResponseDto> {
    return this.activityTypeManager.getActivities(lang);
  }
}